export const TAT_SELLER_GROUP = "Vendedor T&T";
export const TAT_ADMIN_GROUP = "Administrador T&T";
export const TAT_PICKER_GROUP = "Picker T&T";
export const TAT_COURIER_GROUP = "Transportista T&T";

export type TatRole = "vendedor" | "administrador" | "picker" | "transportista";
